import { render, staticRenderFns } from "./CrudOrganizationMembersList.vue?vue&type=template&id=3ef37396&"
import script from "./CrudOrganizationMembersList.vue?vue&type=script&lang=js&"
export * from "./CrudOrganizationMembersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports